// src/lib/analytics.ts

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: any[]) => void;
  }
}

const GA_ID = 'G-2TCD8NH155';

type EventParams = Record<string, string | number | boolean | undefined | null>;

const isBrowser = () => typeof window !== 'undefined';
const hasGtag = () => isBrowser() && typeof window.gtag === 'function';

/**
 * 페이지 뷰 트래킹
 */
export function trackPageView(params: {
  page_path: string;
  page_title?: string;
  page_location?: string;
}) {
  if (!hasGtag()) return;

  window.gtag!('event', 'page_view', {
    page_path: params.page_path,
    page_title: params.page_title ?? document.title,
    page_location: params.page_location ?? window.location.href,
    send_to: GA_ID,
  });
}

/**
 * 일반 이벤트 트래킹
 */
export function trackEvent(eventName: string, params?: EventParams) {
  if (!hasGtag()) return;

  window.gtag!('event', eventName, {
    ...params,
    send_to: GA_ID,
  });
}

/**
 * 로그인 유저의 user_id 설정
 * 교차 기기 분석을 위해 권장됨
 */
export function setUserId(userId: string | null) {
  if (!hasGtag()) return;

  window.gtag!('config', GA_ID, {
    user_id: userId,
  });
}
